import toast from 'react-hot-toast';

/**
 * Handle errors with logging and optional user toast.
 *
 * Use this when:
 * - A user action fails (save, delete, update) and they need to know
 * - In mutation onError callbacks
 * - In try/catch blocks for critical operations
 *
 * Always logs to console.error. Shows toast to user unless options.silent is true.
 *
 * @param {Error} error - The error object
 * @param {string} userMessage - User-facing error message
 * @param {object} [options] - Optional config
 * @param {boolean} [options.silent] - If true, skip toast (log only)
 * @returns {undefined}
 */
export function handleError(error, userMessage, options = {}) {
  console.error(userMessage, error);

  if (!options.silent) {
    toast.error(userMessage);
  }
}

/**
 * Handle warnings with logging only (no user toast).
 *
 * Use this when:
 * - A non-critical operation fails (social feed post, activity logging)
 * - The primary operation succeeded but a secondary one failed
 * - PR detection or background sync fails
 * - Graceful degradation scenarios
 *
 * Always logs to console.warn. Never shows toast to user.
 *
 * @param {string} message - Developer context message
 * @param {Error} error - The error object
 * @returns {undefined}
 */
export function handleWarn(message, error) {
  console.warn(message, error);
}
